module.exports = __webpack_public_path__ + "static/media/androidDevice.fab6ab07.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/androidDevice.gif
 ** module id = 580
 ** module chunks = 0
 **/